/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Current_PasswordInputs */

const en_common_current_password = /** @type {(inputs: Common_Current_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Password`)
};

const es_common_current_password = /** @type {(inputs: Common_Current_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña actual`)
};

/**
* | output |
* | --- |
* | "Current Password" |
*
* @param {Common_Current_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_current_password = /** @type {((inputs?: Common_Current_PasswordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Current_PasswordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_current_password(inputs)
	return en_common_current_password(inputs)
});